import { __, Alert } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  FormWrapper,
  FormColumn,
  ButtonCommonTheme,
  Button,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';
import { ModalForm, ModalFormContainer } from '../../../../theme/theme1/common/styles/main';


class NlpIntentAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData && this.props.editData._id) {
      this.state = {
        intentName: this.props.editData.intentName || "",
        examples: this.props.editData.examples || [{
          "userSays": ""
        }],
        agentId: props.agentId,
        isEdit: true,
       };
    } else {
      this.state = {
        intentName: "",
        examples: [{
          "userSays": ""
        }],
        agentId: props.agentId,
        isEdit: false,
      };
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
     name: '',
     type: '',
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  saveData(e) {
    let _this = this;
    e.preventDefault();
    this.props.clearSearchField();
    let intentName = this.state.intentName.trim();
    let tData = {
      agentId: this.state.agentId,
      intentName: intentName,
      examples: this.state.examples,
    };

    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `setting/nlp-intent/${this.props.editData._id}`,
        tData,
        data => {
          // console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`Name ${tData.name} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `setting/nlp-intent`,
        tData,
        data => {
          if (data && data.message) {
            Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  addField() {
    this.state.examples.push({
      "userSays": ""
    });
    this.setState({ examples: this.state.examples });
  }
  removeField(i) {
    this.state.examples.splice(i, 1);
    this.setState({ examples: this.state.examples });
  }
  renderExample() {
    let length = this.state.examples.length;
    return this.state.examples.map((el, i) => {
      let userSays = el && el.userSays ? el.userSays : "";
      return (
        <div key={i} style={{ display: 'flex', alignItems: 'center' }}>
          <FormColumn>
            {this.renderFormGroup('', {
              placeholder:'Enter your example utterances here',
              defaultValue: '',
              autoFocus: true,
              required: false,
              id: `Examples${i}`,
              value: userSays,
              maxLength: 20,
              onChange: e => {
                let value = e.target.value || "";
                if( this.state.examples && this.state.examples[i] ){
                  this.state.examples[i] = {
                    "userSays" : value
                  }
                }
                this.setState({ examples:  this.state.examples });
              }
            })}
          </FormColumn>
          { length > 1 &&
            <Button
              btnStyle="link"
              size="small"
              onClick={this.removeField.bind(this, i)}
              icon="cancel-1"
            />
          }
        </div>
      );
    });
  }
  render() {
    const { __ } = this.context;
    const { modalType } = this.props;
    // console.log('infoData', this.props.infoData);
    return (
      <ModalForm onSubmit={e => this.saveData(e)}>
      <ModalFormContainer>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Name', {
              placeholder:'Name',
              defaultValue: '',
              autoFocus: true,
              required: true,
              id: 'name',
              value: this.state.intentName,
              onChange: e => {
                if( e.target.value.length > 120 ){
                  return false;
                }
                this.setState({ intentName: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <ColumnTitle>
            <InfoWrapper>
              Examples
              <Button
                onClick={this.addField.bind(this)}
                btnStyle="link"
                size="medium"
                icon="add"
              >
                Add
              </Button>
            </InfoWrapper>
          </ColumnTitle>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderExample()}
          </FormColumn>
        </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme btnSize='medium' type='greyModalBtn' modalBtnTitle='Cancel' OnClick={() => { this.props.closeModal() }} />
          <ButtonCommonTheme type='blueModalBtn' btnType='submit' modalBtnTitle={this.props.editData && this.props.editData._id ? 'Update' : 'Add'} />
        </ModalFooter>
      </ModalForm>
    );
  }
}

NlpIntentAddEdit.propTypes = {
  group: PropTypes.array
};

NlpIntentAddEdit.contextTypes = {
  __: PropTypes.func
};

export default NlpIntentAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/NlpIntenet/components/NlpIntentAddEdit.js